module.exports = {

    GetKeyWords:"/Frontstage/GSJY_Navigation.aspx?type=GetKeyWords",//获取关键词信息
    //顶部导航
    GetList:"/Frontstage/GSJY_Navigation.aspx?type=GetList",//获取所有栏目信息

    //底部导航
    GetBasic:"/Frontstage/GSJY_Navigation.aspx?type=GetBasic",//获取基本信息
    Getyouqing:"/Frontstage/GSJY_Navigation.aspx?type=GetFSL",//获取友情链接信息
    Getxcx:"/Frontstage/GSJY_Navigation.aspx?type=GetFSLXCX",//获取小程序项目信息

    //首页
    GetBanner:"/Frontstage/GSJY_Banner.aspx?type=GetBanner",//获取Banner信息
    GetProcess:"/Frontstage/GSJY_Navigation.aspx?type=GetProcess",//获取服务流程信息
    CreateLeaveMessage:"/Frontstage/GSJY_Navigation.aspx?type=CreateLeaveMessage",//新增留言板信息
    Getzhengshu:"/Frontstage/GSJY_Navigation.aspx?type=GetFSLZS",//获取证书展示信息
    Gethezuoqiye:"/Frontstage/GSJY_Navigation.aspx?type=GetFSLQY",//获取合作企业信息
    Gethezuodaxue:"/Frontstage/GSJY_Navigation.aspx?type=GetFSLDX",//获取合作大学信息
    Getfazhan:"/Frontstage/GSJY_Navigation.aspx?type=GetProcessDetail",//获取发展历程信息
    //资讯
    GetContent:"/Frontstage/GSJY_Navigation.aspx?type=GetContent",//获取资讯列表信息
    GetListTwo:"/Frontstage/GSJY_Navigation.aspx?type=GetListTwo",//获取资讯二级栏目信息
    GetContentById:"/Frontstage/GSJY_Navigation.aspx?type=GetContentById",//获取资讯详情
    GetTJInformat:"/Frontstage/GSJY_Navigation.aspx?type=GetTJInformat",//获取资讯推荐列表信息
    //案例
    GetCase:"/Frontstage/GSJY_Navigation.aspx?type=GetCase",//获取案例列表信息
    GetCaseById:"/Frontstage/GSJY_Navigation.aspx?type=GetCaseById",//获取案例详情
    //合作客户
    GetTeamWork:"/Frontstage/GSJY_Navigation.aspx?type=GetTeamWork",//获取合作伙伴列表
    //技术与服务
    GetService:"/Frontstage/GSJY_Navigation.aspx?type=GetService",//获取技术与服务列表信息
    GetServiceById:"/Frontstage/GSJY_Navigation.aspx?type=GetServiceById",//获取技术与服务详情
    //解决方案
    GetSolution:"/Frontstage/GSJY_Navigation.aspx?type=GetSolution",//获取解决方案列表信息
    GetSolutionById:"/Frontstage/GSJY_Navigation.aspx?type=GetSolutionById",//获取解决方案详情
    GetPartPage:"/Frontstage/GSJY_Navigation.aspx?type=GetPartPage",//获取详情部分页面展示数据
     //服务行业
     GetServiceHY:"/Frontstage/GSJY_Navigation.aspx?type=GetServiceHY",//获取服务行业列表信息
     GetServiceHYById:"/Frontstage/GSJY_Navigation.aspx?type=GetServiceHYById",//获取服务行业详情
     //关于我们
     GetAboutUS:"/Frontstage/GSJY_Navigation.aspx?type=GetAboutUS",//获取关于我们列表信息
     GetAboutUSById:"/Frontstage/GSJY_Navigation.aspx?type=GetAboutUSById",//获取关于我们详情
     Gethezuo:"/Frontstage/GSJY_Navigation.aspx?type=GetFSLHB",//获取合作伙伴信息
};


// WEBPACK FOOTER //
// ./src/config/config.js